import apiSystemSetting from 'utils/http/apiSystemSetting';
import { staticContentStorage } from 'utils/staticContent/staticContentStorage';

interface SystemSetting {
  isContractPricingEnabled: boolean;
  isHealthFeeEnabled: boolean;
  isUploadVideosToCloudflareEnabled: boolean;
  isLitterMediaEnabled: boolean;
}

export const getSystemSetting = async (): Promise<SystemSetting> => {
  const respIsContractPricingEnabled = await apiSystemSetting.getSetting(
    'is-contract-pricing-feature-enabled'
  );
  const respIsHealthFeeEnabled = await apiSystemSetting.getSetting(
    'is-health-fee-feature-enabled'
  );
  const respIsUploadVideosToCloudflareEnabled =
    await apiSystemSetting.getSetting('upload-videos-directly-to-cloudflare');
  const respIsLitterMediaEnabled = await apiSystemSetting.getSetting(
    'is-litter-media-feature-enabled'
  );

  return {
    isContractPricingEnabled: Boolean(respIsContractPricingEnabled.json.value),
    isHealthFeeEnabled: Boolean(respIsHealthFeeEnabled.json.value),
    isUploadVideosToCloudflareEnabled: Boolean(
      respIsUploadVideosToCloudflareEnabled.json.value
    ),
    isLitterMediaEnabled: Boolean(respIsLitterMediaEnabled.json.value),
  };
};

export const isHealthFeeEnabled = (): boolean => {
  const systemSetting = staticContentStorage.getContent().systemSetting;
  return Boolean(systemSetting?.isHealthFeeEnabled);
};

export const isContractEnable = (): boolean => {
  const systemSetting = staticContentStorage.getContent().systemSetting;
  return Boolean(systemSetting?.isContractPricingEnabled);
};

export const isUploadVideoToCloudflareEnabled = (): boolean => {
  const systemSetting = staticContentStorage.getContent().systemSetting;
  return Boolean(systemSetting?.isUploadVideosToCloudflareEnabled);
};

export const isLitterMediaEnabled = (): boolean => {
  const systemSetting = staticContentStorage.getContent().systemSetting;
  return Boolean(systemSetting?.isLitterMediaEnabled);
};
